import { Card } from 'antd'
import styled, { css } from 'styled-components'

const StyledUnknownWordsCard = styled(Card)`
  ${props =>
    props.isDisabled &&
    css`
      border-color: #e21b1b;
    `};
`

export default StyledUnknownWordsCard
